"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _omit = _interopRequireDefault(require("lodash/omit"));

var _reactDesc = require("react-desc");

var _InputField = require("../../atoms/InputField");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var schema = (0, _reactDesc.describe)({
  displayName: 'Select'
});
schema.propTypes = _objectSpread({}, (0, _omit.default)(_InputField.schema.makePropTypes(), ['children', 'maxLength', 'onChange', 'showCharacterCount']), {
  hideClearButton: _reactDesc.PropTypes.bool.description('Whether or not to hide the clear button after selecting an item').defaultValue('false'),
  clearButtonLabel: _reactDesc.PropTypes.string.description("A hidden label value for the clear button. The select component's label is available within the string for clarity.").defaultValue('Clear {label} value'),
  containerSelector: _reactDesc.PropTypes.string.description("A CSS selector to the element where the Select should be rendered in, or \"parent\" to render the Select in-place.").defaultValue('body'),
  defaultValue: _reactDesc.PropTypes.string.description('The ID of the option that should be selected by default.'),
  actions: _reactDesc.PropTypes.oneOfType([_reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.object), _reactDesc.PropTypes.shape({
    left: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.object),
    right: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.object)
  })]).description('A collection of objects, each containing a subset of props valid for a Button component. Check the notes on the OptionsList.'),
  onChange: _reactDesc.PropTypes.func.description(''),
  onHide: _reactDesc.PropTypes.func.description('A callback which is triggered when the popover is closed'),
  onShow: _reactDesc.PropTypes.func.description('A callback which is triggered when the popover is opened'),
  options: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.shape({
    decoration: _reactDesc.PropTypes.shape({
      type: _reactDesc.PropTypes.oneOf(['Avatar', 'Badge'])
    }),
    disabled: _reactDesc.PropTypes.bool,
    id: _reactDesc.PropTypes.string.description('The id for an option in the dropdown list.'),
    label: _reactDesc.PropTypes.string.description('The label text for an option in the dropdown list.'),
    value: _reactDesc.PropTypes.string.description('The value for an option in the dropdown list.')
  })).description('The array of data for the options that will be rendered').isRequired,
  renderOptionLabel: _reactDesc.PropTypes.func.description('Function to customize render of option labels, called with the item value'),
  value: _reactDesc.PropTypes.string.description('The ID of the option that is selected. If provided, controlling the Select must be handled externally. Overrides `defaultValue`.'),
  zIndex: _reactDesc.PropTypes.number.description('Sets the z-index style property of the options list')
});
var _default = schema;
exports.default = _default;